export default "__VITE_ASSET__BnxQZDZn__"